import React from 'react';
import Parser from 'html-react-parser';

function HtmlParser({ text }: { text: string }) {
  return text !== '<p><br></p>' && text !== '' ? <>{Parser(text)}</> : <></>;
}

export default HtmlParser;
